import React from 'react';
import './IntroSplash.css';

export default function IntroSplash({ className = '' }) {
  return (
    <div className={`IntroSplash${className ? ` ${className}` : ''}`} aria-label="Amelle intro">
      <div className="IntroSplash-mark" aria-label="Amelle logo">
        <div className="IntroSplash-logoWrap">
          <img
            className="IntroSplash-logo"
            src={`${process.env.PUBLIC_URL}/amelle.png`}
            alt="Amelle"
            draggable="false"
          />
        </div>
      </div>
    </div>
  );
}
